module.exports = __webpack_public_path__ + "media/images/dashboard/progress-card-bg-2c40b453d637bc1a5adbce33dd338ce1.jpg";